import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { LanguageTokenType } from 'src/domains/layouts/state/languagesState/LanguagesUtils';
import { ErrorLink } from 'src/domains/players/webview/components/WithdrawAndDeposit/depositProcedure/realexProvider/RealexTab.style';
import { Messages } from 'src/domains/layouts/webview/components/Messages/Messages';
import { LanguagesState } from 'src/domains/layouts/state/languagesState/LanguagesState';
import { ErrorMessageType as DepositErrorMessageType } from 'src/domains/players/webview/components/WithdrawAndDeposit/depositProcedure/topUpProcedureParts/errorMessages/DepositErrorMessages.state';

interface ErrorMessageType extends DepositErrorMessageType {
    message: string;
    languagesState: LanguagesState;
}

const FailedDepositRestrictionErrorMessage = observer(
    'failedDepositRestriction',
    ({ languagesState, message }: ErrorMessageType) => (
        <div>
            {languagesState.translateTokens(message, (singleParam: LanguageTokenType) => {
                if (singleParam.tag === 'responsibleGamblingTools') {
                    return (
                        <ErrorLink
                            to={{ account: 'limits' }}
                            dataTest='error'
                        >
                            responsible gambling tools
                        </ErrorLink>
                    );
                }
                return undefined;
            })}
        </div>
    )
);

const LimitReachedErrorMessage = observer(
    'LimitReachedErrorMessage',
    ({ languagesState, message }: ErrorMessageType) => (
        <div>
            {languagesState.translateTokens(message, (singleParam: LanguageTokenType) => {
                if (singleParam.tag === 'link') {
                    return (
                        <ErrorLink
                            to={{ account: 'limits' }}
                            dataTest='error'
                        >
                            <I18n
                                langKey='account.top-up.errors.deposit-limit-reached.link'
                                defaultText='here'
                            />
                        </ErrorLink>
                    );
                }
                return undefined;
            })}
        </div>
    )
);

export const mapErrorsMessages = (error: DepositErrorMessageType, languagesState: LanguagesState): React.ReactNode => {
    if (error.type === 'failed-deposit-restriction') {
        return (
            <Messages
                type='error'
                marginTop='8px'
                key={error.type}
                message={
                    <FailedDepositRestrictionErrorMessage
                        type={error.type}
                        message={error.message}
                        languagesState={languagesState}
                    />
                }
            />
        );
    }

    if (error.type === 'limit-reached') {
        return (
            <Messages
                type='error'
                marginTop='8px'
                key={error.type}
                message={
                    <LimitReachedErrorMessage
                        type={error.type}
                        message={error.message}
                        languagesState={languagesState}
                    />
                }
            />
        );
    }

    return (
        <Messages
            type='error'
            marginTop='8px'
            key={error.type}
            message={error.message}
        />
    );
};
